import { CSSProperties, ReactNode } from "react";

import { cn } from "@/components/common/utils";

type FeedCardVariant = "standard" | "horizontal-video" | "vertical-mobile";
// standard: Regular feed cards with full padding (FeaturedComedianFeedCard)
// horizontal-video: Traditional video layout with reduced padding (VideoFeedCardHorizontal, VideoFeedCardSkeleton) - used on both mobile and desktop
// vertical-mobile: TikTok-style full-screen vertical videos with no padding (VideoFeedCardVertical)

export default function FeedCard({
  children,
  className,
  style,
  variant = "standard",
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  variant?: FeedCardVariant;
}) {
  const variantStyles = {
    standard: "px-[14px] md:px-6 md:pt-6 md:pb-6 py-4",
    "horizontal-video": "px-0 md:px-6 py-3 md:py-6",
    "vertical-mobile": "p-0",
  };

  return (
    <div
      className={cn(
        "bg-[#F5F5F5] rounded-md",
        variantStyles[variant],
        className
      )}
      style={style}
      data-testid="feed-card"
    >
      {children}
    </div>
  );
}
